// ============================================================================
// NEİZLESEM - small, dependency-free helpers
// ============================================================================

/** Minimal className combiner (no external deps). */
export function cn(...inputs: Array<string | false | null | undefined>): string {
  return inputs.filter(Boolean).join(' ')
}

const PLACEHOLDER =
  'data:image/svg+xml;charset=UTF-8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="342" height="513" viewBox="0 0 342 513">
      <rect width="342" height="513" fill="#16161a"/>
      <g fill="#3a3a42" transform="translate(171 230)">
        <circle r="34" cy="-6"/>
        <rect x="-52" y="44" width="104" height="20" rx="10"/>
      </g>
      <text x="171" y="330" fill="#55555f" font-family="sans-serif" font-size="18"
        text-anchor="middle">Görsel yok</text>
    </svg>`
  )

/** Poster fallback used when an image is missing / broken. */
export const POSTER_PLACEHOLDER = PLACEHOLDER

/** Return a usable poster url or the placeholder. */
export function posterUrl(poster: string | null | undefined): string {
  return poster && poster.startsWith('http') ? poster : PLACEHOLDER
}

/** Turn a rating number into a fixed one-decimal string, or '—'. */
export function formatRating(rating: number | null | undefined): string {
  if (rating === null || rating === undefined || Number.isNaN(rating)) return '—'
  return rating.toFixed(1)
}

/** '169 min' -> '2s 49dk' style Turkish runtime. */
export function formatRuntime(runtime: string | null | undefined, minutes?: number | null): string {
  const total = minutes ?? parseRuntimeMinutes(runtime)
  if (!total) return runtime || ''
  const h = Math.floor(total / 60)
  const m = total % 60
  if (h && m) return `${h}s ${m}dk`
  if (h) return `${h}s`
  return `${m}dk`
}

function parseRuntimeMinutes(runtime: string | null | undefined): number | null {
  if (!runtime) return null
  const m = runtime.match(/(\d+)/)
  return m ? parseInt(m[1], 10) : null
}

/** Content type label in Turkish. */
export function typeLabel(type: string): string {
  return type === 'series' ? 'Dizi' : 'Film'
}

/** Build the canonical detail path for a content item. */
export function detailPath(type: string, id: string): string {
  return `/detay/${type}/${id}`
}

/** Debounce helper. */
export function debounce<T extends (...args: any[]) => void>(fn: T, delay: number): T {
  let timer: ReturnType<typeof setTimeout>
  return ((...args: any[]) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }) as T
}
